import paths from '../../../routes/paths';
import { loggedIn } from '../../../routes/conditional';

// Disabling eslint as this is just the first export.
// eslint-disable-next-line import/prefer-default-export
export const page = {
  path: paths.createOrder.complete,
  isAllowed: [loggedIn],
};
